export const exist = (e) => {
    let val = false;
  
    e.length != 0 ? (val = true) : console.warn(`Module not found`);
    return val;
  };
  